import { Box, FormControl, MenuItem, Select, Stack, Typography, useTheme } from '@mui/material';

type Option = {
  id: number;
  name: string;
};

type SelectFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
  info?: boolean;
};

export default function FormFieldSelect({
  label,
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  info = false,
}: SelectFieldProps) {
  const theme = useTheme();

  return (
    <Box sx={{ mt: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%' }}>
        {info ? (
          <Typography variant="fieldHeader" sx={{ whiteSpace: 'nowrap' }} width={theme.spacing(19)}>
            {label}
          </Typography>
        ) : (
          <Typography variant="fieldHeader" sx={{ whiteSpace: 'nowrap' }} width={theme.spacing(15)}>
            {label}
          </Typography>
        )}

        <FormControl
          fullWidth
          size="small"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        >
          <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty
            sx={{ width: '100%' }}
            disabled={disabled}
          >
            {placeholder && (
              <MenuItem value="">
                <em>{placeholder}</em>
              </MenuItem>
            )}
            {options.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
}
